import emailjs from '@emailjs/browser';

export type FormData = {
  [key: string]: string;
};

export async function sendEmail(
  data: FormData,
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  templateId: string = process.env.NEXT_PUBLIC_EMAILJS_TEMPLATE_ID!,
) {
  const response = await emailjs.send(
    process.env.NEXT_PUBLIC_EMAILJS_SERVICE_ID ?? '',
    templateId,
    {
      ...data,
    },
    {
      publicKey: process.env.NEXT_PUBLIC_EMAILJS_PUBLIC_KEY ?? '',
    },
  );
  return response;
}

export async function subscribeNewsletter(email: string, tags: string[] = []) {
  const apiEndpoint = '/api/newsletter';

  const response = await fetch(apiEndpoint, {
    method: 'POST',
    body: JSON.stringify({ email, tags }),
    cache: 'no-cache',
  });
  const res = await response.json();
  return res;
}
